module.exports = __webpack_public_path__ + "static/media/iceberg.69819111.png";